export default class EstadoCivilService {
    constructor(resource) {
        this._resource = resource('corpore/estadoCivil{/id}');
    }

    get(id) {
        return this._resource
            .get({id})
            .then(res => res.json(), err => {
                console.log(err);
                throw new Error('Não foi possível obter os estados civis');
            })
    }

    getEstadosCivis() {
        return this._resource
            .get()
            .then(res => res.json(), err => {
                console.log(err);
                throw new Error('Não foi possível obter o estado civil');
            })
    }
}



// WEBPACK FOOTER //
// ./src/domain/corpore/EstadoCivilService.js